import React from "react";

export default function WhatShapeHeader() {
  return (
    <div className="w-full flex flex-col 2xl:gap-[30px] gap-[10px]">
      <div
        className="justify-center text-[#00040b] text-base uppercase
      border-b border-[#fff] 2xl:pb-[50px] pb-[5px] tracking-tight"
      >
        Strive to lead
      </div>
      <div className="flex flex-col gap-[15px]">
        <h2 className="[font-family:'Clash Display'] font-[500] clash-font text-[length:var(--section-title)] leading-[120%]">
          Driven by Innovation and{" "}
          <span className="text-[#225BD4]">Thoughtful Excellence</span>
        </h2>
        <p className="text-[#949596] text-[clamp(0.9375rem,0.4664rem+0.9815vw,2rem)] leading-[160%]">
          Count on our expertise to develop reliable, secure, and scalable web
          and mobile app solutions aligned with your business goals and needs.
          At Konstant, we thrive to build a long-lasting relationship with our
          clients by delivering cutting-edge solutions that drive long-term
          growth and success. By combining deep technical expertise with a
          long-term partnership mindset, we deliver solutions that add lasting
          value and support sustainable growth for our clients.
        </p>
      </div>
    </div>
  );
}
